import * as THREE from 'three'
import gsap from 'gsap'
import TweenMax from 'gsap'

export default class Raycast {
    constructor(world) {
        this.world = world
        this.scene = this.world.scene
        this.sizes = this.world.sizes
        this.camera = this.world.camera.perspectiveCamera
        this.controls = this.world.camera.controls
        this.flare = this.world.world.environment.light
        this.currentIntersect = null

        // Setup
        this.raycaster = new THREE.Raycaster()
        this.mouse = new THREE.Vector2()
        this.setMesh()
        this.setMouse()

        // Booleans
        this.clickable = true
        this.hover_play = true

        // Poi active
        this.poi1Active = true
        this.poi2Active = false
        this.poi3Active = false
        this.poi4Active = false
        this.poi5Active = false
        this.poi6Active = false
        this.poi7Active = false
        this.poi8Active = false
    }

    setMesh() {
        //////////////////////////////////////////////
        //////////////////////////////////////////////
        this.badge1 = this.world.world.route.badge1
        this.badge1Top = this.world.world.route.badge1Top
        this.badge2 = this.world.world.route.badge2
        this.badge2Top = this.world.world.route.badge2Top
        this.badge3 = this.world.world.route.badge3
        this.badge3Top = this.world.world.route.badge3Top
        this.badge4 = this.world.world.route.badge4
        this.badge4Top = this.world.world.route.badge4Top
        this.badge5 = this.world.world.route.badge5
        this.badge5Top = this.world.world.route.badge5Top
        this.badge6 = this.world.world.route.badge6
        this.badge6Top = this.world.world.route.badge6Top
        this.badge7 = this.world.world.route.badge7
        this.badge7Top = this.world.world.route.badge7Top
        this.badge8 = this.world.world.route.badge8
        this.badge8Top = this.world.world.route.badge8Top
        //////////////////////////////////////////////
        //////////////////////////////////////////////
        this.image1Mix = this.world.world.route.uniforms1.transition2
        this.image2Mix = this.world.world.route.uniforms2.transition2
        this.image3Mix = this.world.world.route.uniforms3.transition2
        this.image4Mix = this.world.world.route.uniforms4.transition2
        this.image5Mix = this.world.world.route.uniforms5.transition2
        this.image6Mix = this.world.world.route.uniforms6.transition2
        this.image7Mix = this.world.world.route.uniforms7.transition2
        this.image8Mix = this.world.world.route.uniforms8.transition2
        //////////////////////////////////////////////
        //////////////////////////////////////////////
        this.arnhem_rand = this.world.world.route.arnhem_rand
        this.ede_rand = this.world.world.route.ede_rand
        this.apeldoorn_rand = this.world.world.route.apeldoorn_rand
        this.uddel_rand = this.world.world.route.uddel_rand
        this.barneveld_rand = this.world.world.route.barneveld_rand
        this.wageningen_rand = this.world.world.route.wageningen_rand
        this.renkum_rand = this.world.world.route.renkum_rand
        this.nijmegen_rand = this.world.world.route.nijmegen_rand
        //////////////////////////////////////////////
        //////////////////////////////////////////////
        this.b24 = this.world.world.models_world.b24_hitbox
        this.b24_follow = false
        this.spitfire = this.world.world.models_world.spitfire_hitbox
        this.spitfire_follow = false
        //////////////////////////////////////////////
        //////////////////////////////////////////////
        this.div_container = this.world.world.route.div_container
        this.div_text = this.world.world.route.div_text
        //////////////////////////////////////////////
        //////////////////////////////////////////////

        // De objecten die in deze array staan zijn zichtbaar voor de muis raycast
        this.objectsToTest = [
            this.badge1,
            this.badge2,
            this.badge3,
            this.badge4,
            this.badge5,
            this.badge6,
            this.badge7,
            this.badge8,

            this.b24,
            this.spitfire,
        ]
    }

    setMouse() {
        // Mouse move
        // Mouse move
        window.addEventListener('mousemove', (event) => {
            this.mouse.x = event.clientX / this.sizes.width * 2 - 1
            this.mouse.y = - (event.clientY / this.sizes.height) * 2 + 1
        });

        // Touch move - for mobile devices
        window.addEventListener('touchmove', (event) => {
            if (! this.clickable) return;
            // Get the first touch point
            const touch = event.touches[0];

            // Calculate normalized device coordinates
            this.mouse.x = touch.clientX / this.sizes.width * 2 - 1
            this.mouse.y = - (touch.clientY / this.sizes.height) * 2 + 1
        }, { passive: false });

        // Also set initial touch position
        window.addEventListener('touchstart', (event) => {
            const touch = event.touches[0];
            this.mouse.x = touch.clientX / this.sizes.width * 2 - 1
            this.mouse.y = - (touch.clientY / this.sizes.height) * 2 + 1
        });

        // Mouse click events
        function handleClickOrTouch(event) {
            if (!this.currentIntersect || !(event.type === 'click' || event.type === 'touchstart')) return;

            //setting the distance so the animation starts from the current position
            const distance = this.camera.position.distanceTo(this.controls.target)

            //setting the angle to the current angle
            const polarAngle = this.controls.getPolarAngle();

            //poi click sound
            this.world.world.audio.poi_click_sound.play()

            //stop all audio
            for (let i = 1; i <= 8; i++) {
                if (this.world.world.audio[`poi_${i}_sound`].isPlaying === true) { this.world.world.audio[`poi_${i}_sound`].stop() }
            }

            //Showing the poi text
            this.poi_text_ani = gsap.to(".text_div", { delay: 3, duration: 3, ease: 'power3.InOut', opacity: 1 })

            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //Airplane cams /////////////////////////////////////////////////////////////////////////////////
            //b24 follow cam
            if (this.currentIntersect.object === this.b24 && this.b24_follow === false) {
                this.b24_follow = true
                this.poi_text_ani.kill()
            }
            if (this.currentIntersect.object === this.spitfire && this.spitfire_follow === false) {
                this.spitfire_follow = true
                this.poi_text_ani.kill()
            }

            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //POI 1 /////////////////////////////////////////////////////////////////////////////////////////
            if (this.currentIntersect.object === this.badge1 && this.poi1Active === true) {
                //Setup controls
                this.controls.enabled = false
                this.world.camera.scroll = false
                this.poi2Active = true
                this.clickable = false

                //poi sound
                this.poi_1_audio_in = this.world.world.audio.poi_1_audio_in
                this.poi_1_sound = this.world.world.audio.poi_1_sound
                this.poi_1_sound.gain.gain.value = 0
                this.poi_1_audio_in.to(this.poi_1_sound.gain.gain, 2, { value: 1 });
                this.poi_1_sound.play()
                this.poi_1_audio_in.play()

                //settting camera
                this.controls.maxDistance = distance
                this.controls.minPolarAngle = polarAngle

                //zoom closer to the poi
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 3.5 })

                //change camera angle -- math.PI is 180 graden
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 2.09 })

                gsap.to(this.camera.position, { duration: 3, ease: 'power3.InOut', y: 3.5 })
                gsap.to(this.controls.target, {
                    duration: 3,
                    ease: 'power2.Out',
                    x: 4.8,
                    y: 0,
                    z: 1.3
                })

                //closing the badge
                gsap.to(this.badge1Top.material.map.offset, { duration: 3, ease: 'power2.out', x: 1 })

                //swapping the poi text
                this.div_text.innerHTML = ''
                this.div_text.appendChild(this.world.world.route.h1)
                this.div_text.appendChild(this.world.world.route.p1)
                this.div_text.appendChild(this.world.world.route.p1Video);
                this.div_container.position.set(4.8, 0.13, 4)
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //POI 2 /////////////////////////////////////////////////////////////////////////////////////////
            if (this.currentIntersect.object === this.badge2 && this.poi2Active === true) {
                //Setup controls
                this.controls.enabled = false
                this.world.camera.scroll = false
                this.poi3Active = true
                this.clickable = false

                //poi sound
                this.poi_2_audio_in = this.world.world.audio.poi_2_audio_in
                this.poi_2_sound = this.world.world.audio.poi_2_sound
                this.poi_2_sound.gain.gain.value = 0
                this.poi_2_audio_in.to(this.poi_2_sound.gain.gain, 2, { value: 1 });
                this.poi_2_sound.play()
                this.poi_2_audio_in.play()

                //settting camera
                this.controls.maxDistance = distance
                this.controls.minPolarAngle = polarAngle

                //zoom closer to the poi
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 3.5 })

                //change camera angle -- math.PI is 180 graden
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 2.17 })

                //setting camera rotation
                gsap.to(this.controls, {
                    duration: 3, ease: 'power1.InOut',
                    minAzimuthAngle: Math.PI / 2.3,
                    maxAzimuthAngle: Math.PI / 2.3
                })

                gsap.to(this.camera.position, { duration: 3, ease: 'power3.InOut', y: 3.5 })
                gsap.to(this.controls.target, {
                    duration: 3,
                    ease: 'power2.Out',
                    x: -5.5,
                    y: 0,
                    z: -1.5
                })

                //closing the badge
                gsap.to(this.badge2Top.material.map.offset, { duration: 3, ease: 'power2.out', x: 1 })

                //swapping the poi text
                this.div_text.innerHTML = ''
                this.div_text.appendChild(this.world.world.route.h2)
                this.div_text.appendChild(this.world.world.route.p2)
                this.div_text.appendChild(this.world.world.route.p2Video);
                this.div_container.position.set(-2.8, 0.3, -0.94)
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //POI 3 /////////////////////////////////////////////////////////////////////////////////////////
            if (this.currentIntersect.object === this.badge3 && this.poi3Active === true) {
                //Setup controls
                this.controls.enabled = false
                this.world.camera.scroll = false
                this.poi4Active = true
                this.clickable = false

                //poi sound
                this.poi_3_audio_in = this.world.world.audio.poi_3_audio_in
                this.poi_3_sound = this.world.world.audio.poi_3_sound
                this.poi_3_sound.gain.gain.value = 0
                this.poi_3_audio_in.to(this.poi_3_sound.gain.gain, 2, { value: 1 });
                this.poi_3_sound.play()
                this.poi_3_audio_in.play()

                //settting camera
                this.controls.maxDistance = distance
                this.controls.minPolarAngle = polarAngle

                //zoom closer to the poi
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 3.5 })

                //change camera angle -- math.PI is 180 graden
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 2.3 })

                //setting camera rotation
                gsap.to(this.controls, {
                    duration: 3, ease: 'power1.InOut',
                    minAzimuthAngle: Math.PI / -5,
                    maxAzimuthAngle: Math.PI / -5
                })

                gsap.to(this.camera.position, { duration: 3, ease: 'power3.InOut', y: 3.5 })
                gsap.to(this.controls.target, {
                    duration: 3,
                    ease: 'power2.Out',
                    x: 6,
                    y: 0,
                    z: -13.5
                })

                //closing the badge
                gsap.to(this.badge3Top.material.map.offset, { duration: 3, ease: 'power2.out', x: 1 })

                //swapping the poi text
                this.div_text.innerHTML = ''
                this.div_text.appendChild(this.world.world.route.h3)
                this.div_text.appendChild(this.world.world.route.p3)
                this.div_text.appendChild(this.world.world.route.p3Video);
                this.div_container.position.set(4.61, 0.4, -11.6)
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //POI 4 /////////////////////////////////////////////////////////////////////////////////////////
            if (this.currentIntersect.object === this.badge4 && this.poi4Active === true) {
                //Setup controls
                this.controls.enabled = false
                this.world.camera.scroll = false
                this.poi5Active = true
                this.clickable = false

                //poi sound
                this.poi_4_audio_in = this.world.world.audio.poi_4_audio_in
                this.poi_4_sound = this.world.world.audio.poi_4_sound
                this.poi_4_sound.gain.gain.value = 0
                this.poi_4_audio_in.to(this.poi_4_sound.gain.gain, 2, { value: 1 });
                this.poi_4_sound.play()
                this.poi_4_audio_in.play()

                //settting camera
                this.controls.maxDistance = distance
                this.controls.minPolarAngle = polarAngle

                //zoom closer to the poi
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 3.5 })

                //change camera angle -- math.PI is 180 graden
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 2.11 })

                //setting camera rotation
                gsap.to(this.controls, {
                    duration: 3, ease: 'power1.InOut',
                    minAzimuthAngle: Math.PI / -6.5,
                    maxAzimuthAngle: Math.PI / -6.5
                })

                gsap.to(this.camera.position, { duration: 3, ease: 'power3.InOut', y: 3.5 })
                gsap.to(this.controls.target, {
                    duration: 3,
                    ease: 'power2.Out',
                    x: 1.3,
                    y: 0,
                    z: -14.7
                })

                //closing the badge
                gsap.to(this.badge4Top.material.map.offset, { duration: 3, ease: 'power2.out', x: 1 })

                //swapping the poi text
                this.div_text.innerHTML = ''
                this.div_text.appendChild(this.world.world.route.h4)
                this.div_text.appendChild(this.world.world.route.p4)
                this.div_text.appendChild(this.world.world.route.p4Video);
                this.div_container.position.set(-0.064, 0.25, -12.1)
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //POI 5 /////////////////////////////////////////////////////////////////////////////////////////
            if (this.currentIntersect.object === this.badge5 && this.poi5Active === true) {
                //Setup controls
                this.controls.enabled = false
                this.world.camera.scroll = false
                this.poi6Active = true
                this.clickable = false

                //poi sound
                this.poi_5_audio_in = this.world.world.audio.poi_5_audio_in
                this.poi_5_sound = this.world.world.audio.poi_5_sound
                this.poi_5_sound.gain.gain.value = 0
                this.poi_5_audio_in.to(this.poi_5_sound.gain.gain, 2, { value: 1 });
                this.poi_5_sound.play()
                this.poi_5_audio_in.play()

                //settting camera
                this.controls.maxDistance = distance
                this.controls.minPolarAngle = polarAngle

                //zoom closer to the poi
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 3.5 })

                //change camera angle -- math.PI is 180 graden
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 2.3 })

                //setting camera rotation
                gsap.to(this.controls, {
                    duration: 3, ease: 'power1.InOut',
                    minAzimuthAngle: Math.PI / - 8,
                    maxAzimuthAngle: Math.PI / - 8
                })

                gsap.to(this.camera.position, { duration: 3, ease: 'power3.InOut', y: 3.5 })
                gsap.to(this.controls.target, {
                    duration: 3,
                    ease: 'power2.Out',
                    x: -7,
                    y: 0,
                    z: -8.2
                })

                //closing the badge
                gsap.to(this.badge5Top.material.map.offset, { duration: 3, ease: 'power2.out', x: 1 })

                //swapping the poi text
                this.div_text.innerHTML = ''
                this.div_text.appendChild(this.world.world.route.h5)
                this.div_text.appendChild(this.world.world.route.p5)
                this.div_text.appendChild(this.world.world.route.p5Video);
                this.div_container.position.set(-7.91, 0.42, -6.0)
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //POI 6 /////////////////////////////////////////////////////////////////////////////////////////
            if (this.currentIntersect.object === this.badge6 && this.poi6Active === true) {
                //Setup controls
                this.controls.enabled = false
                this.world.camera.scroll = false
                this.poi7Active = true
                this.clickable = false

                //poi sound
                this.poi_6_audio_in = this.world.world.audio.poi_6_audio_in
                this.poi_6_sound = this.world.world.audio.poi_6_sound
                this.poi_6_sound.gain.gain.value = 0
                this.poi_6_audio_in.to(this.poi_6_sound.gain.gain, 2, { value: 1 });
                this.poi_6_sound.play()
                this.poi_6_audio_in.play()

                setTimeout(() => {
                    this.world.world.route.badge6Top.visible = false
                    this.world.world.route.badge6Bottom.visible = false
                }, 3000)

                //settting camera
                this.controls.maxDistance = distance
                this.controls.minPolarAngle = polarAngle

                //zoom closer to the poi
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 3.5 })

                //change camera angle -- math.PI is 180 graden
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 2.2 })

                //setting camera rotation
                gsap.to(this.controls, {
                    duration: 3, ease: 'power1.InOut',
                    minAzimuthAngle: Math.PI / -2.2,
                    maxAzimuthAngle: Math.PI / -2.2
                })

                gsap.to(this.camera.position, { duration: 3, ease: 'power3.InOut', y: 3.5 })
                gsap.to(this.controls.target, {
                    duration: 3,
                    ease: 'power2.Out',
                    x: -1.65,
                    y: 0,
                    z: 2.6
                })

                //closing the badge
                gsap.to(this.badge6Top.material.map.offset, { duration: 3, ease: 'power2.out', x: 1 })

                //swapping the poi text
                this.div_text.innerHTML = ''
                this.div_text.appendChild(this.world.world.route.h6)
                this.div_text.appendChild(this.world.world.route.p6)
                this.div_text.appendChild(this.world.world.route.p6Video);
                this.div_container.position.set(-4.5, 0.35, 3.013)
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //POI 7 /////////////////////////////////////////////////////////////////////////////////////////
            if (this.currentIntersect.object === this.badge7 && this.poi7Active === true) {
                //Setup controls
                this.controls.enabled = false
                this.world.camera.scroll = false
                this.poi8Active = true
                this.clickable = false

                //poi sound
                this.poi_7_audio_in = this.world.world.audio.poi_7_audio_in
                this.poi_7_sound = this.world.world.audio.poi_7_sound
                this.poi_7_sound.gain.gain.value = 0
                this.poi_7_audio_in.to(this.poi_7_sound.gain.gain, 2, { value: 1 });
                this.poi_7_sound.play()
                this.poi_7_audio_in.play()

                setTimeout(() => {
                    this.world.world.route.badge6Top.visible = false
                    this.world.world.route.badge6Bottom.visible = false
                }, 3000)

                //settting camera
                this.controls.maxDistance = distance
                this.controls.minPolarAngle = polarAngle

                //zoom closer to the poi
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 3.5 })

                //change camera angle -- math.PI is 180 graden
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 2.2 })

                gsap.to(this.camera.position, { duration: 3, ease: 'power3.InOut', y: 3.5 })
                gsap.to(this.controls.target, {
                    duration: 3,
                    ease: 'power2.Out',
                    x: -0.75,
                    y: 0,
                    z: 1.9
                })

                //closing the badge
                gsap.to(this.badge7Top.material.map.offset, { duration: 3, ease: 'power2.out', x: 1 })

                //swapping the poi text
                this.div_text.innerHTML = ''
                this.div_text.appendChild(this.world.world.route.h7)
                this.div_text.appendChild(this.world.world.route.p7)
                this.div_text.appendChild(this.world.world.route.p7Video);
                this.div_container.position.set(-0.75, 0.32, 4.7)
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////
            //POI 8 /////////////////////////////////////////////////////////////////////////////////////////
            if (this.currentIntersect.object === this.badge8 && this.poi8Active === true) {
                //Setup controls
                this.controls.enabled = false
                this.world.camera.scroll = false
                this.clickable = false

                //poi sound
                this.poi_8_audio_in = this.world.world.audio.poi_8_audio_in
                this.poi_8_sound = this.world.world.audio.poi_8_sound
                this.poi_8_sound.gain.gain.value = 0
                this.poi_8_audio_in.to(this.poi_8_sound.gain.gain, 2, { value: 1 });
                this.poi_8_sound.play()
                this.poi_8_audio_in.play()

                setTimeout(() => {
                    this.world.world.route.badge6Top.visible = false
                    this.world.world.route.badge6Bottom.visible = false
                }, 3000)

                //settting camera
                this.controls.maxDistance = distance
                this.controls.minPolarAngle = polarAngle

                //zoom closer to the poi
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', maxDistance: 3.5 })

                //change camera angle -- math.PI is 180 graden
                gsap.to(this.controls, { duration: 3, ease: 'power1.InOut', minPolarAngle: Math.PI / 2.2 })

                //setting camera rotation
                gsap.to(this.controls, {
                    duration: 3, ease: 'power1.InOut',
                    minAzimuthAngle: Math.PI / -2,
                    maxAzimuthAngle: Math.PI / -2
                })

                gsap.to(this.camera.position, { duration: 3, ease: 'power3.InOut', y: 3.5 })
                gsap.to(this.controls.target, {
                    duration: 3,
                    ease: 'power2.Out',
                    x: 4,
                    y: 0,
                    z: 10.7
                })

                //closing the badge
                gsap.to(this.badge8Top.material.map.offset, { duration: 3, ease: 'power2.out', x: 1 })

                //swapping the poi text
                this.div_text.innerHTML = ''
                this.div_text.appendChild(this.world.world.route.h8)
                this.div_text.appendChild(this.world.world.route.p8)
                this.div_text.appendChild(this.world.world.route.p8Video);
                this.div_container.position.set(1.6, 0.22, 10.7)
            }
        }

        window.addEventListener('click', handleClickOrTouch.bind(this))
        window.addEventListener('touchstart', handleClickOrTouch.bind(this))
        window.addEventListener('touchend', handleClickOrTouch.bind(this))
    }

    update() {
        // Hovering
        this.raycaster.setFromCamera(this.mouse, this.camera)
        this.intersects = this.raycaster.intersectObjects(this.objectsToTest, true)

        this.currentIntersect = null

        //clickable
        if (this.clickable) {
            this.objectsToTest.map(el => el.scale.set(1, 1, 1));

            if (this.intersects.length > 0) {
                this.intersects.map(el => {
                    this.currentIntersect = el;
                    el.object.scale.set(1.15, 1.15, 1.15);
                    //objects not to scale
                    this.b24.scale.set(1, 1, 1);
                    this.spitfire.scale.set(1, 1, 1);
                });
            }
        }

        //Hover specifieke objecten
        if (this.currentIntersect) {
            //audio on hover
            if (this.hover_play === true) {
                // play the hover sound
                if (this.world.world.audio.poi_hover_sound.isPlaying === true) {
                    this.world.world.audio.poi_hover_sound.stop()
                }
                if (this.currentIntersect.object === this.b24 || this.currentIntersect.object === this.spitfire) {
                    // dont play audio on airplane hover
                } else {
                    this.world.world.audio.poi_hover_sound.play()
                    this.hover_play = false
                }
            }

            //transition timing
            var inAni = 10
            var outAni = 3

            //animation on hover
            if (this.currentIntersect.object === this.badge1 && this.poi1Active === true) {
                gsap.to(this.badge1Top.material.map.offset, { duration: 1, ease: 'power2.out', x: 0 })
                gsap.to(this.image1Mix, { duration: inAni, ease: 'ease.out', value: 1 })
                gsap.to(this.arnhem_rand.position, { duration: 3, ease: 'power2.out', y: 0.12 })
            } else {
                gsap.to(this.badge1Top.material.map.offset, { duration: 1.5, ease: 'power2.out', x: 1 })
                gsap.to(this.image1Mix, { duration: outAni, ease: 'ease.in', value: 0 })
                gsap.to(this.arnhem_rand.position, { duration: 3, ease: 'power2.out', y: 0 })
            }

            if (this.currentIntersect.object === this.badge2 && this.poi2Active === true) {
                gsap.to(this.badge2Top.material.map.offset, { duration: 1, ease: 'power2.out', x: 0 })
                gsap.to(this.image2Mix, { duration: inAni, ease: 'ease.out', value: 1 })
                gsap.to(this.ede_rand.position, { duration: 3, ease: 'power2.out', y: 0.12 })
            } else {
                gsap.to(this.badge2Top.material.map.offset, { duration: 1.5, ease: 'power2.out', x: 1 })
                gsap.to(this.image2Mix, { duration: outAni, ease: 'ease.in', value: 0 })
                gsap.to(this.ede_rand.position, { duration: 3, ease: 'power2.out', y: 0 })
            }

            if (this.currentIntersect.object === this.badge3 && this.poi3Active === true) {
                gsap.to(this.badge3Top.material.map.offset, { duration: 1, ease: 'power2.out', x: 0 })
                gsap.to(this.image3Mix, { duration: inAni, ease: 'ease.out', value: 1 })
                gsap.to(this.apeldoorn_rand.position, { duration: 3, ease: 'power2.out', y: 0.12 })
            } else {
                gsap.to(this.badge3Top.material.map.offset, { duration: 1.5, ease: 'power2.out', x: 1 })
                gsap.to(this.image3Mix, { duration: outAni, ease: 'ease.in', value: 0 })
                gsap.to(this.apeldoorn_rand.position, { duration: 3, ease: 'power2.out', y: 0 })
            }

            if (this.currentIntersect.object === this.badge4 && this.poi4Active === true) {
                gsap.to(this.badge4Top.material.map.offset, { duration: 1, ease: 'power2.out', x: 0 })
                gsap.to(this.image4Mix, { duration: inAni, ease: 'ease.out', value: 1 })
                gsap.to(this.uddel_rand.position, { duration: 3, ease: 'power2.out', y: 0.12 })
            } else {
                gsap.to(this.badge4Top.material.map.offset, { duration: 1.5, ease: 'power2.out', x: 1 })
                gsap.to(this.image4Mix, { duration: outAni, ease: 'ease.in', value: 0 })
                gsap.to(this.uddel_rand.position, { duration: 3, ease: 'power2.out', y: 0 })
            }

            if (this.currentIntersect.object === this.badge5 && this.poi5Active === true) {
                gsap.to(this.badge5Top.material.map.offset, { duration: 1, ease: 'power2.out', x: 0 })
                gsap.to(this.image5Mix, { duration: inAni, ease: 'ease.out', value: 1 })
                gsap.to(this.barneveld_rand.position, { duration: 3, ease: 'power2.out', y: 0.15 })
            } else {
                gsap.to(this.badge5Top.material.map.offset, { duration: 1.5, ease: 'power2.out', x: 1 })
                gsap.to(this.image5Mix, { duration: outAni, ease: 'ease.in', value: 0 })
                gsap.to(this.barneveld_rand.position, { duration: 3, ease: 'power2.out', y: 0 })
            }

            if (this.currentIntersect.object === this.badge6 && this.poi6Active === true) {
                gsap.to(this.badge6Top.material.map.offset, { duration: 1, ease: 'power2.out', x: 0 })
                gsap.to(this.image6Mix, { duration: inAni, ease: 'ease.out', value: 1 })
                gsap.to(this.wageningen_rand.position, { duration: 3, ease: 'power2.out', y: 0.12 })
            } else {
                gsap.to(this.badge6Top.material.map.offset, { duration: 1.5, ease: 'power2.out', x: 1 })
                gsap.to(this.image6Mix, { duration: outAni, ease: 'ease.in', value: 0 })
                gsap.to(this.wageningen_rand.position, { duration: 3, ease: 'power2.out', y: 0 })
            }

            if (this.currentIntersect.object === this.badge7 && this.poi7Active === true) {
                gsap.to(this.badge7Top.material.map.offset, { duration: 1, ease: 'power2.out', x: 0 })
                gsap.to(this.image7Mix, { duration: inAni, ease: 'ease.out', value: 1 })
                gsap.to(this.renkum_rand.position, { duration: 3, ease: 'power2.out', y: 0.15 })
            } else {
                gsap.to(this.badge7Top.material.map.offset, { duration: 1.5, ease: 'power2.out', x: 1 })
                gsap.to(this.image7Mix, { duration: outAni, ease: 'ease.in', value: 0 })
                gsap.to(this.renkum_rand.position, { duration: 3, ease: 'power2.out', y: 0 })
            }

            if (this.currentIntersect.object === this.badge8 && this.poi8Active === true) {
                gsap.to(this.badge8Top.material.map.offset, { duration: 1, ease: 'power2.out', x: 0 })
                gsap.to(this.image8Mix, { duration: inAni, ease: 'ease.out', value: 1 })
                gsap.to(this.nijmegen_rand.position, { duration: 3, ease: 'power2.out', y: 0.15 })
            } else {
                gsap.to(this.badge8Top.material.map.offset, { duration: 1.5, ease: 'power2.out', x: 1 })
                gsap.to(this.image8Mix, { duration: outAni, ease: 'ease.in', value: 0 })
                gsap.to(this.nijmegen_rand.position, { duration: 3, ease: 'power2.out', y: 0 })
            }
        } else {
            this.hover_play = true
        }

        //airplane cams
        if (this.b24_follow === true) {
            this.world.camera.scroll = false

            this.camera.position.x = this.world.world.models_world.airplane_b24.position.x
            this.camera.position.y = this.world.world.models_world.airplane_b24.position.y + 1
            this.camera.position.z = this.world.world.models_world.airplane_b24.position.z + 3

            this.controls.minPolarAngle = Math.PI / 2.5
            this.controls.maxPolarAngle = Math.PI / 2.5
        }

        if (this.spitfire_follow === true) {
            this.world.camera.scroll = false

            this.camera.position.x = this.world.world.models_world.airplane_spitfire.position.x
            this.camera.position.y = this.world.world.models_world.airplane_spitfire.position.y + 0.8
            this.camera.position.z = this.world.world.models_world.airplane_spitfire.position.z + 2.1

            this.controls.minPolarAngle = Math.PI / 2.5
            this.controls.maxPolarAngle = Math.PI / 2.5
        }
    }
}